export default __webpack_public_path__ + "670c6e209bff2699d91cd6352d3f945c.ogg";